import { render, staticRenderFns } from "./ProductAdditionalFeeListItem.vue?vue&type=template&id=27155c8c&scoped=true&"
import script from "./ProductAdditionalFeeListItem.vue?vue&type=script&lang=js&"
export * from "./ProductAdditionalFeeListItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductAdditionalFeeListItem.vue?vue&type=style&index=0&id=27155c8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27155c8c",
  null
  
)

export default component.exports